import dayjs from "dayjs";
import { formatValue } from "../pages/Performance Dashboard/MetricCard";

const convertMilliSecToReadable = (differenceInMs) => {
    const differenceInSeconds = Math.floor(differenceInMs / 1000);
    const differenceInMinutes = Math.floor(differenceInSeconds / 60);
    const differenceInHours = Math.floor(differenceInMinutes / 60);
    const differenceInDays = Math.floor(differenceInHours / 24);

    const remainingHours = differenceInHours % 24;
    const remainingMinutes = differenceInMinutes % 60;
    const remainingSeconds = differenceInSeconds % 60;

    if (differenceInDays > 0) {
      return `${differenceInDays}d ${remainingHours}h`;
    } else if (differenceInHours > 0) {
      return `${differenceInHours}h ${remainingMinutes}m`;
    } else if (differenceInMinutes > 0) {
      return `${differenceInMinutes}m ${remainingSeconds}s`;
    } else if (remainingSeconds > 0) {
      return `${remainingSeconds}s`;
    } else {
      return `${differenceInMs}ms`;
    }
  };

  function convertToDecimalDays(timeString) {
    const match = timeString.match(/(\d+)d\s*(\d+)h/);
    if (!match) return 0;
  
    const days = parseInt(match[1], 10); 
    const hours = parseInt(match[2], 10);
    const hoursAsDays = hours / 24;
    
    return formatValue(days + hoursAsDays);
  }

  const formatDateToDDMMMYYYY = (dateString) => {
    const date = dayjs(dateString);
    if (!date.isValid()) {
      return ''
    }
    return date.format("DD MMM YYYY");
};

function generateRandomNumber() {
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  return array[0] / (0xffffffff + 1);
}

  export {convertMilliSecToReadable,convertToDecimalDays,formatDateToDDMMMYYYY, generateRandomNumber};


  